import jQuery from 'jquery';

require.ensure([], () => {
    // enable lang switcher select change event
    jQuery('.language-switcher select').change(function(event) {
        event.preventDefault();

        window.location.href = jQuery(this).val();
    });

    // Custom Select styling
    require('select2');

    jQuery('.language-switcher select').select2({
        minimumResultsForSearch: Infinity
    });
}, 'lang-switcher');



// WEBPACK FOOTER //
// ./resources/assets/js/lib/language-switcher.js